"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayoutContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _shared = require("choerodon-ui/shared");
var _utils = require("../configure/utils");
var LayoutContext = (0, _shared.getContext)(_shared.Symbols.LayoutContext, {
  getPrefixCls: _utils.getPrefixCls
});
var BaseLayoutContextProvider = function LayoutContextProvider(props) {
  var children = props.children,
    siderHook = props.siderHook,
    getGlobalPrefixCls = props.getPrefixCls;
  var value = (0, _react.useMemo)(function () {
    return {
      siderHook: siderHook,
      getPrefixCls: getGlobalPrefixCls
    };
  }, [getGlobalPrefixCls, siderHook]);
  return /*#__PURE__*/_react["default"].createElement(LayoutContext.Provider, {
    value: value
  }, children);
};
BaseLayoutContextProvider.displayName = 'LayoutContextProvider';
var LayoutContextProvider = /*#__PURE__*/(0, _react.memo)(BaseLayoutContextProvider);
exports.LayoutContextProvider = LayoutContextProvider;
var _default = LayoutContext;
exports["default"] = _default;